import { Vessel } from '@navstation-portal/vessels/data-model/vessel';

export interface AppStoreState {
  selectedVesselId: string | undefined;
  defaultVesselId: string | undefined;
  selectedVessel: Vessel | undefined;
  isLoadingFullOverlay: boolean;
}

export const INITIAL_APP_STORE_STATE: AppStoreState = {
  selectedVesselId: undefined,
  defaultVesselId: undefined,
  selectedVessel: undefined,
  isLoadingFullOverlay: false,
};
